module.exports = __webpack_public_path__ + "fonts/159057f94171c5adb2e54af3b96d03ba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Shell/scenes/Header/img/css_logo_small.svg
// module id = 1305
// module chunks = 0